module.exports = __webpack_public_path__ + "static/img/图层 25.d23915ef.png";